var exports = {
  "D": "title__l_yjdG",
  "n": "link__LL3Gb0",
};

module.exports = exports;
